<template>
    <div class="nav-wrapper" :data-open="opened">
        <slot name="toggle"/>
        <div class="nav-menu__lead">
            <slot name="lead"/>
        </div>

        <nav :class="classes">
            <ul class="nav-menu__items">
                <slot name="items"/>
            </ul>
        </nav>
    </div>
</template>

<script>
import VueTypes from 'vue-types'
    export default {
        props: {
            opened: VueTypes.bool.def(true),
        },
        computed: {
            classes(){
                const classes = "nav-menu";
                return this.opened ? `${classes} opened` : classes;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @use "~@scss/components/NavMenu" as *;
</style>